module.exports = __webpack_public_path__ + "static/media/artem_sapegin.11c836f4.jpg";